import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

/** Form actions only. The owning page handles validation, persistence, discard and route guards. */
@Component({
  selector: 'app-contextual-savebar',
  templateUrl: './contextual-savebar.component.html',
  styleUrls: ['./contextual-savebar.component.scss']
})
export class ContextualSavebarComponent implements OnDestroy {
  @Input() active = true;
  @Input() dirty = false;
  @Input() saving = false;
  @Input() saved = false;
  @Input() blocked = false;
  @Input() errorKey = '';
  @Input() contextKey = '';
  @Input() contextText = '';
  @Output() save = new EventEmitter<void>();
  @Output() discard = new EventEmitter<void>();
  @ViewChild('bar') private bar?: ElementRef<HTMLElement>;
  private focusTimer?: ReturnType<typeof setTimeout>;

  constructor(private host: ElementRef<HTMLElement>, private modal: NgbModal) {}

  get visible(): boolean { return this.active && (this.dirty || this.saving || this.saved); }
  get actionsDisabled(): boolean { return this.saving || this.blocked; }

  requestSave(): void {
    if (this.active && this.dirty && !this.actionsDisabled) this.save.emit();
  }

  requestDiscard(): void {
    if (this.active && this.dirty && !this.actionsDisabled) this.discard.emit();
  }

  @HostListener('document:keydown', ['$event'])
  onSaveShortcut(event: KeyboardEvent): void {
    if (!this.active || !(event.ctrlKey || event.metaKey) || event.key.toLowerCase() !== 's' || this.modal.hasOpenModals()) return;
    event.preventDefault();
    this.requestSave();
  }

  @HostListener('document:input')
  @HostListener('document:focusin')
  keepEditingFieldVisible(): void {
    if (!this.active) return;
    clearTimeout(this.focusTimer);
    this.focusTimer = setTimeout(() => {
      const field = document.activeElement as HTMLElement;
      const form = this.host.nativeElement.closest('form, [data-savebar-editor]');
      const bar = this.bar?.nativeElement;
      if (!bar || !form?.contains(field) || this.host.nativeElement.contains(field)) return;
      const bounds = field.getBoundingClientRect();
      if (bounds.top < bar.getBoundingClientRect().bottom + 16 && bounds.bottom > 0) {
        field.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    }, 0);
  }

  ngOnDestroy(): void { clearTimeout(this.focusTimer); }
}
